import React, { useState } from "react";

const Referrals = () => {
  // Sample referral data - replace with API data
  const [referralData] = useState({
    referralCode: "JOHN123",
    referralLink: "https://yourvtu.com/ref/JOHN123",
    totalReferrals: 15,
    activeReferrals: 12,
    totalEarnings: 25000,
    pendingEarnings: 5000,
    referralBonus: 1000, // Amount earned per referral
  });

  const [referralHistory] = useState([
    {
      id: 1,
      username: "user123",
      date: "2024-03-20",
      status: "active",
      earnings: 1000,
    },
    {
      id: 2,
      username: "newuser456",
      date: "2024-03-19",
      status: "pending",
      earnings: 1000,
    },
    // Add more referral history
  ]);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    // Add toast notification here
  };

  return (
    <div className="max-w-6xl mx-auto">
      {/* Header */}
      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        <h2 className="text-2xl font-semibold text-navy">Referral Program</h2>
        <p className="text-charcoal-gray mt-2">
          Earn ₦{referralData.referralBonus.toLocaleString()} for each successful referral
        </p>
      </div>

      {/* Referral Stats */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        {/* Total Referrals */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-charcoal-gray">Total Referrals</p>
              <h3 className="text-2xl font-semibold text-navy mt-1">
                {referralData.totalReferrals}
              </h3>
            </div>
            <span className="material-icons text-emerald-green text-3xl">
              group_add
            </span>
          </div>
        </div>

        {/* Active Referrals */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-charcoal-gray">Active Referrals</p>
              <h3 className="text-2xl font-semibold text-navy mt-1">
                {referralData.activeReferrals}
              </h3>
            </div>
            <span className="material-icons text-emerald-green text-3xl">
              verified_user
            </span>
          </div>
        </div>

        {/* Total Earnings */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-charcoal-gray">Total Earnings</p>
              <h3 className="text-2xl font-semibold text-navy mt-1">
                ₦{referralData.totalEarnings.toLocaleString()}
              </h3>
            </div>
            <span className="material-icons text-emerald-green text-3xl">
              payments
            </span>
          </div>
        </div>

        {/* Pending Earnings */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-charcoal-gray">Pending Earnings</p>
              <h3 className="text-2xl font-semibold text-navy mt-1">
                ₦{referralData.pendingEarnings.toLocaleString()}
              </h3>
            </div>
            <span className="material-icons text-emerald-green text-3xl">
              pending
            </span>
          </div>
        </div>
      </div>

      {/* Referral Link Section */}
      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        <h3 className="text-lg font-semibold text-navy mb-4">Your Referral Link</h3>
        <div className="space-y-4">
          {/* Referral Code */}
          <div className="flex items-center justify-between p-4 bg-soft-white rounded-lg">
            <div>
              <p className="text-sm text-charcoal-gray">Referral Code</p>
              <p className="text-navy font-medium">{referralData.referralCode}</p>
            </div>
            <button
              onClick={() => copyToClipboard(referralData.referralCode)}
              className="text-emerald-green hover:text-emerald-600 p-2"
            >
              <span className="material-icons">content_copy</span>
            </button>
          </div>

          {/* Referral Link */}
          <div className="flex items-center justify-between p-4 bg-soft-white rounded-lg">
            <div className="flex-1 mr-4">
              <p className="text-sm text-charcoal-gray">Referral Link</p>
              <p className="text-navy font-medium truncate">
                {referralData.referralLink}
              </p>
            </div>
            <button
              onClick={() => copyToClipboard(referralData.referralLink)}
              className="text-emerald-green hover:text-emerald-600 p-2"
            >
              <span className="material-icons">content_copy</span>
            </button>
          </div>

          {/* Share Buttons */}
          <div className="flex gap-4 mt-4">
            <button className="flex items-center gap-2 bg-[#25D366] text-white px-4 py-2 rounded-lg hover:bg-opacity-90">
              <span className="material-icons">whatsapp</span>
              Share on WhatsApp
            </button>
            <button className="flex items-center gap-2 bg-[#1DA1F2] text-white px-4 py-2 rounded-lg hover:bg-opacity-90">
              <span className="material-icons">share</span>
              Share on Twitter
            </button>
          </div>
        </div>
      </div>

      {/* Referral History */}
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <div className="p-6 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-navy">Referral History</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-charcoal-gray uppercase tracking-wider">
                  Username
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-charcoal-gray uppercase tracking-wider">
                  Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-charcoal-gray uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-charcoal-gray uppercase tracking-wider">
                  Earnings
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {referralHistory.map((referral) => (
                <tr key={referral.id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-navy">
                    {referral.username}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-charcoal-gray">
                    {new Date(referral.date).toLocaleDateString()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span
                      className={`px-2 py-1 text-xs rounded-full ${
                        referral.status === "active"
                          ? "bg-green-100 text-green-800"
                          : "bg-yellow-100 text-yellow-800"
                      }`}
                    >
                      {referral.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-navy">
                    ₦{referral.earnings.toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* How it Works */}
      <div className="bg-white rounded-lg shadow-md p-6 mt-6">
        <h3 className="text-lg font-semibold text-navy mb-4">How it Works</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-emerald-green text-white flex items-center justify-center">
              1
            </div>
            <div>
              <h4 className="font-medium text-navy">Share Your Link</h4>
              <p className="text-charcoal-gray text-sm mt-1">
                Share your unique referral link with friends and family
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-emerald-green text-white flex items-center justify-center">
              2
            </div>
            <div>
              <h4 className="font-medium text-navy">They Sign Up</h4>
              <p className="text-charcoal-gray text-sm mt-1">
                When they register using your link and make their first transaction
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-emerald-green text-white flex items-center justify-center">
              3
            </div>
            <div>
              <h4 className="font-medium text-navy">You Earn</h4>
              <p className="text-charcoal-gray text-sm mt-1">
                You earn ₦{referralData.referralBonus.toLocaleString()} for each successful referral
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Referrals;